import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ClothingConfiguredMarker
} from '../../../models/clothing.model';
import { CLOTHING_MARKER_TYPES, ClothingSelectOption } from './clothing.constants';

interface ClothingConfiguredMarkerDraft {
  markerCode: string;
  markerType: string;
  active?: boolean;
}

@Component({
  selector: 'app-clothing-admin-marker-directory',
  templateUrl: './clothing-admin-marker-directory.component.html',
  styleUrls: ['./clothing-admin-marker-directory.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingAdminMarkerDirectoryComponent {
  @Input() hideHeader = false;
  @Input() markers: ClothingConfiguredMarker[] = [];
  @Input() draftMarker: ClothingConfiguredMarkerDraft;
  @Input() isSaving = false;
  @Output() createMarker = new EventEmitter<void>();
  @Output() saveMarker = new EventEmitter<ClothingConfiguredMarker>();
  @Output() deleteMarker = new EventEmitter<string>();

  markerTypes: ClothingSelectOption[] = CLOTHING_MARKER_TYPES;

  submitCreate() {
    this.createMarker.emit();
  }

  submitSave(marker: ClothingConfiguredMarker) {
    this.saveMarker.emit(marker);
  }

  submitDelete(markerId: string) {
    this.deleteMarker.emit(markerId);
  }

  trackByMarker(index: number, marker: ClothingConfiguredMarker): string {
    return marker.id;
  }

  trackByType(index: number, type: ClothingSelectOption): string {
    return type.value;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-marker-directory.component.ts